// Every read (including manual refresh) supersedes the previous read. Transport
// abort is an optimization; the ticket also fences transports that ignore it.
export function createLatestWorkspaceRead({read,onStart,onValue,onError,onFinish}) {
  let generation=0,controller=null,disposed=false
  return {
    async load(query) {
      if(disposed)return
      const ticket=++generation
      controller?.abort()
      const current=new AbortController();controller=current
      const active=()=>!disposed&&ticket===generation&&!current.signal.aborted
      onStart()
      try {const result=await read(query,current.signal);if(active())onValue(result)}
      catch(error){if(active()&&error.name!=='AbortError')onError(error)}
      finally{if(active())onFinish()}
    },
    cancel(){generation++;controller?.abort();controller=null},
    dispose(){disposed=true;generation++;controller?.abort();controller=null},
    activate(){disposed=false},
  }
}
